import { takeLeading, put, all, call } from "redux-saga/effects";
import HomeActionTypes from "./home.types";
import {
  homeSyncFinish,
  thingSyncFinish,
  favoriteSyncFinish,
} from "./home.actions";
import { log } from "../../helpers/core.helper";
import UserService from "../../services/user/user.service";

export function* getHomeData({ payload }) {
  try {
    let initialSynced = true;
    let message = "success";
    var bannerList = null;

    const res = yield UserService.getGridData(payload);
    if (res.error != null) {
      initialSynced = false;
      bannerList = null;
      message = res.error.response.data.message;
    } else {
      if (res["status"]) {
        bannerList = res["data"];
        initialSynced = true;
        message = res["message"];
      } else {
        initialSynced = false;
        bannerList = null;
        message = res["message"];
      }
    }

    if (bannerList != null && bannerList.length > 0) {
      bannerList = [
        ...bannerList.filter((x) => x.images != null && x.images.length > 0),
        ...bannerList.filter((x) => x.images == null || x.images.length === 0),
      ];
    }
    yield put(
      homeSyncFinish({ initialSynced, syncingHome: false, message, bannerList })
    );
  } catch (err) {
    log("home.sagas", "getBannerData", err);
    yield put(
      homeSyncFinish({
        initialSynced: false,
        syncingHome: false,
        message: err,
        bannerList: null,
      })
    );
  }
}

export function* getThingData({ payload }) {
  try {
    let message = "success";
    var thingList = null;

    const res = yield UserService.getGridData(payload);
    if (res.error != null) {
      thingList = null;
      message = res.error.response.data.message;
    } else {
      if (res["status"]) {
        thingList = res["data"];
        message = res["message"];
      } else {
        thingList = null;
        message = res["message"];
      }
    }
    if (thingList != null && thingList.length > 0) {
      thingList = [
        ...thingList.filter((x) => x.images != null && x.images.length > 0),
        ...thingList.filter((x) => x.images == null || x.images.length === 0),
      ];
    }

    yield put(thingSyncFinish({ message, thingList }));
  } catch (err) {
    log("home.sagas", "getBannerData", err);
    yield put(
      thingSyncFinish({
        message: err,
        thingList: null,
      })
    );
  }
}

export function* getFavoriteData({ payload }) {
  try {
    let message = "success";
    var favoriteList = null;
    const res = yield UserService.getFavoritesData(payload);
    if (res.error != null) {
      favoriteList = null;
      message = res.error.response.data.message;
    } else {
      if (res["status"]) {
        favoriteList = res["data"];
        message = res["message"];
      } else {
        favoriteList = null;
        message = res["message"];
      }
    }
    if (favoriteList != null && favoriteList.length > 0) {
      favoriteList = favoriteList.map((x) => ({ ...x, isFavorite: 1 }));
      favoriteList = [
        ...favoriteList.filter((x) => x.images != null && x.images.length > 0),
        ...favoriteList.filter(
          (x) => x.images == null || x.images.length === 0
        ),
      ];
    }
    yield put(favoriteSyncFinish({ message, favoriteList }));
  } catch (err) {
    log("home.sagas", "getBannerData", err);
    yield put(
      favoriteSyncFinish({
        message: err,
        favoriteList: null,
      })
    );
  }
}

export function* homeSyncStart() {
  yield takeLeading(HomeActionTypes.HOME_SYNC_START, getHomeData);
}

export function* thingSyncStart() {
  yield takeLeading(HomeActionTypes.THING_SYNC_START, getThingData);
}

export function* favoriteSyncStart() {
  yield takeLeading(HomeActionTypes.FAVORITE_SYNC_START, getFavoriteData);
}

/**
 * Initialise all local sagas
 */
export function* homeSagas() {
  yield all([
    call(homeSyncStart),
    call(thingSyncStart),
    call(favoriteSyncStart),
  ]);
}
